module.exports = {
    "Empty": `Tom`
};


//# sourceMappingURL=nb-NO.main.js.map
